import styled from 'astroturf/react';

const Content = styled('div')`
  position: relative;
  padding: 0 60px 25px 60px;
  min-height: 100%;
  margin-left: 1px;
  height: 100%;
  overflow-y: auto;
  width: calc(100% - 60px);
  left: 60px;

  &.collapsed {
    width: calc(100% - 215px);
    left: 215px;
  }

  &.noPadding {
    padding: 0;
  }
`;

const Layout = styled('div')`
  position: relative;
  height: 100%;
`;

export default { Content, Layout };
